import api from "../services/api"

const MAX_SIZE = 300 * 1024 * 1024 // 300MB

const uploadFile = async (file, data = {}, onProgress) => {
    try {
        if (file.size > MAX_SIZE) {
            throw new Error("Arquivo muito grande! Máximo permitido: 300MB!")
        }

        const formData = new FormData()
        formData.append("file", file)

        Object.entries(data).forEach(([key, value]) => {
            formData.append(key, value)
        })

        const response = await api.post("/files/upload", formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
            timeout: 1000 * 60 * 10,
            onUploadProgress: (event) => {
                if (event.loaded && typeof onProgress === "function") {
                    const percent = Math.round((event.loaded / event.total) * 100)
                    onProgress(percent, event)
                }
            }
        })
        return response?.data?.data
    } catch (err) {
        throw err
    }
}

export { uploadFile }